import React from 'react';
import HeaderTable from '../headerTable/headerTable';
import './noDataMessage.sass';

export default function NoDataMessage({ title }) {
  return (
    <div className="positions-table__component">
      <HeaderTable title={title} />
      <div className="positions-table__sport">
        <div className="positions-table__no-data">
          <div className="no-data-content">
            <h3>Información por confirmar</h3>
            <p>Los datos de la tabla de posiciones se actualizarán próximamente.</p>
          </div>
        </div>
      </div>
    </div>
  );
}